"use client";

import Button from "@/components/ui/Button";
import { useTranslations } from "@/i18n/client";
import { useRouter } from "@/i18n/routing";
import { useLogout } from "@frend-digital/centra/client";
import styles from "./index.module.css";

const SignOut = () => {
  const logout = useLogout();
  const router = useRouter();
  const t = useTranslations("myAccount.accountPage.signOut");

  const handleSignOut = () => {
    logout.mutate(undefined as never, {
      onSuccess: () => {
        router.replace("/");
      },
    });
  };

  return (
    <Button className={styles.logoutButton} mode="link" onClick={handleSignOut}>
      {t("button")}
    </Button>
  );
};

export default SignOut;
